import * as React from 'react';

import styled from '@emotion/styled';
import { __ } from '../../../helpers/TranslationService';
import { IFooterContactInfo } from '../../../interfaces/IFooter';

interface IFooterContactInfoProps extends IFooterContactInfo {
    className?: string;
    title: string;
    content?: string;
}

const ContactsLi = styled.li`
    min-width: 294px;
`;
export class FooterContactInfo extends React.Component<
    IFooterContactInfoProps,
    Record<string, unknown>
> {
    render() {
        const { title, content, jobButton } = this.props;
        return (
            <ContactsLi>
                <h3 className="text-uppercase">{title}</h3>
                <div dangerouslySetInnerHTML={{ __html: content || '' }} />
                <div className="footerJobButton">
                    {Boolean(jobButton) && (
                        <>
                            <a
                                href={jobButton?.targetUrl}
                                className="newsletterFooterButton btn btn-more"
                                role="button"
                            >
                                {jobButton?.linkTitle}
                            </a>
                            &nbsp;
                        </>
                    )}
                    <a
                        href={__('http://blog.dreamlines.it/', 'dreamlines')}
                        title={__('Cruise News', 'dreamlines')}
                        className="btn btn-more"
                    >
                        {__('Cruise News', 'dreamlines')}
                    </a>
                </div>
            </ContactsLi>
        );
    }
}
